import { WizardPluginConfig } from '../models/configs/wizard-plugin-config';
import { DecoratorFactory } from '../decoration-base/decorator-factory';

/**
 * Unique key for WizardPlugin decorator.
 */
export const WIZARD_PLUGIN_KEY = 'wizardplugin';

/**
 * Create wizard plugin decorator
 */
export const WizardPlugin = DecoratorFactory.create<WizardPluginConfig>(WIZARD_PLUGIN_KEY);
